<template lang="pug">
div
  v-dialog(v-model="loadingAsync" width="400" persistent)
    v-card
      v-card-title Синхронизация отчётов
      v-card-text
        v-progress-linear(
          :value="percent"
          color="deep-purple accent-4"
          rounded
          height="8"
        )
        div.mt-2.archive-info Синхронизировано: {{ syncedPoints }} из {{ syncProgress.total }} торговых точек
  v-dialog( v-model="loadingReport" width="unset" :persistent="loadingReport" )
    v-card
      v-card-title Загрузка торговых точек...
      v-card-text( v-if="loadingReport" )
        v-progress-linear( color="deep-purple accent-4" indeterminate rounded height="6" )
  PhotosCarousel( v-if="!loadingAsync && duplicatesPhoto.length" )
  router-view
</template>

<script>
import { mapState } from 'vuex'
import PhotosCarousel from './PhotosCarousel.vue';

export default {
  components: {
    PhotosCarousel
  },
  computed: {
    ...mapState('pointreport', ['loadingAsync', 'syncProgress', 'loadingReport', 'duplicatesPhoto']),
    percent() {
      const { done, total } = this.syncProgress
      return total > 0 ? Math.min(100, (done / total) * 100) : 0
    },

    syncedPoints() {
      return Math.floor(this.syncProgress.done);
    }
  }
}
</script>
<style scoped>
.archive-info {
  font-size: 10px;
  line-height: 22px;
  color: #00000099;
}
</style>